module.exports = __webpack_public_path__ + "static/media/filterCancelIcon.27347556.svg";